import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { ApContentService } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';

import { TokensBrowserService } from '../tokens-browser.service';

import content from './pincode.content.json';
import { PincodeValidator } from './pincode.validator';

/**
 * @module PincodeModule
 * @ngdoc component
 * @name PincodeComponent
 */
@Component({
    selector: 'tokens-browser-pincode',
    templateUrl: 'pincode.component.html',
    styleUrls: ['./pincode.component.scss'],
    standalone: false
})
export class PincodeComponent implements OnInit {
    @Output()
    public editPincode: EventEmitter<string> = new EventEmitter();

    @Output()
    public back: EventEmitter<void> = new EventEmitter();

    public form: UntypedFormGroup;
    public buttonsDisabled: boolean;

    public errorMessage: ErrorMessages;

    public constructor(
        private readonly contentService: ApContentService,
        private readonly tokensBrowserService: TokensBrowserService
    ) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.form = new UntypedFormGroup({
            pincode: new UntypedFormControl('', {
                validators: [Validators.required, Validators.minLength(5), PincodeValidator.validate]
            })
        });
        this.tokensBrowserService.setFocusOnActiveInput('tokens-browser-pincode ap-pincode-input input');

        this.errorMessage = {
            required: this.contentService.get(`tokens.browser.pincode.error.required`),
            pincode: this.contentService.get(`tokens.browser.pincode.error.pincode`)
        };
    }

    public submit(): void {
        this.buttonsDisabled = true;
        if (this.form.valid) {
            this.editPincode.emit(this.form.get('pincode').value);
        } else {
            this.buttonsDisabled = false;
            Object.keys(this.form.controls).forEach((field) => {
                const control = this.form.get(field);
                control.markAsTouched();
                control.markAsDirty();
            });
        }
    }

    public goBack(): void {
        this.back.emit();
    }
}
